<section class="network-infrastructure-container" [class.svb-page]="isSvbPage">
  <span class="oval-left" inlineSVG="/assets/home/ovals-left-v2.svg"></span>
  <span class="oval-right" inlineSVG="/assets/home/ovals-right-v2.svg"></span>
  <div class="network-infrastructure-content">
    <div class="network-infrastructure-fold">
      <h1>Networked Fund Infrastructure</h1>
      <p>
        Flow streamlines raising and operating funds by connecting participants and the workflows between
        them.
      </p>
    </div>
  </div>
  <div class="fractal-diagram-container">
    <span data-testid="fractal-diagram" inlineSVG="/assets/home/fractal-diagram-v2.svg"></span>
  </div>
</section>
